export default __webpack_public_path__ + "static/media/Globe.1e142b42.png";